// extracted by mini-css-extract-plugin
module.exports = {"root":"InsurgencyMap_root__xL2VR","tableDataOuter":"InsurgencyMap_tableDataOuter__H4ADX","scrollbar":"InsurgencyMap_scrollbar__VXUq6","thumb":"InsurgencyMap_thumb__JuDKn"};